import List from './List';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'permission_groups',
  inputShow: gql`
    query permissionGroups($input: PermissionGroupQueryInput) {
      permissionGroups(input: $input) {
        permissions
        id
        display_name
        __typename
      }
    }
  `,
  list: List,
  // create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Permission Groups',
  },
};
